import React from "react"
import VideoPageCardSection from "../video-page-card-section/VideoPageCardSection"
import * as classNames from "./VideoCardArticlesList.module.scss"
import Section from "../../../../core/layout/main/section/Section"

function VideoCardArticleList({ articles }) {
  return (
    <Section className={classNames.background}>
      {articles.map((item, i) => {
        return (
          <VideoPageCardSection
            media={item.media?.data?.attributes.url}
            mediaLink={item.linkMedia}
            typeMedia={item.typeMedia}
            cardTitle={item.cardTitle}
            cardText={item.cardText}
            cardButtonText={item.cardButtonText}
            isCardAlignLeft={item.isCardAlignLeft}
            alternativeText={item.media?.data?.attributes.alternativeText}
            videoPreview={item.videoPreview?.data?.attributes.videoPreview}
            mime={item.media?.data?.attributes.mime}
            linkedArticle={item.article?.data?.attributes.slug}
            title={item.title}
            description={item.description}
          />
        )
      })}
    </Section>
  )
}
export const name = "VideoCardArticleList"

export const init = (componentData) => {
  return <VideoCardArticleList  key={componentData.id} articles={componentData.videoCardArticles} />
}

export default VideoCardArticleList
